import { theme, spacing, isMobile, mobileSpacing, typography, buttonStyles, mergeStyles } from '../styles/theme';

export default function SimpleHeader({ showBackButton = true }) {
  return (
    <div style={{
      padding: '15px 30px',
      backgroundColor: theme.bg.dark,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: theme.shadow.small,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      ...(isMobile() && {
        padding: `${mobileSpacing.md} ${mobileSpacing.lg}`,
      })
    }}>
      {/* Logo */}
      <img 
        src="/logo-light.svg" 
        alt="Judgy"
        style={{
          height: '40px',
          width: 'auto',
          cursor: 'pointer',
          ...(isMobile() && {
            height: '32px',
          })
        }}
        onClick={() => window.location.href = '/'}
      />

      {/* Back to Home button */}
      {showBackButton && (
        <button
          onClick={() => window.location.href = '/'}
          style={mergeStyles(
            buttonStyles.base,
            buttonStyles.secondary,
            buttonStyles.small,
            {
              backgroundColor: 'transparent',
              color: theme.text.inverse,
              border: `2px solid ${theme.border.light}`,
              ...(isMobile() && {
                fontSize: typography.mobileFontSize.sm,
              })
            }
          )}
        >
          ← Back to Chat
        </button>
      )}
    </div>
  );
}